import { Component, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../Model/Common/common.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { TaxCategoryFormComponent } from '../tax-category-form/tax-category-form.component';
import { CommonModule } from '@angular/common';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { IncometaxService } from '../../../Model/Incometax/incometax.service';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';

@Component({
  selector: 'app-tax-category',
  standalone: true,
  imports: [CommonModule, DataTablesModule],
  templateUrl: './tax-category.component.html',
  styleUrl: './tax-category.component.scss'
})
export class TaxCategoryComponent {
  isDisabled: boolean = false;
  TableDatas: any[] = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    protected common: CommonService,
    private toast: ToastService,
    private tooltip: TooltipService,
    private modalService: NgbModal,
    private incometax: IncometaxService,
    private download: DownloadSampleService
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.TaxCategoryMasterSelectLoad();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  TaxCategoryMasterSelectLoad() {
    this.isDisabled = true;
    this.incometax.TaxCategoryMasterSelectLoad({ 'SelectType': 'S', ESS_TaxCategoryMasterID: 0 }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.TableDatas = Object.values(response.Table);
        } else {
          this.TableDatas = [];
        }
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  addTaxCategory(ID: any) {
    if ((this.common.PageRight.IsAdd && ID == 0) || (this.common.PageRight.IsEdit && ID > 0)) {
      const modalRef = this.modalService.open(TaxCategoryFormComponent);
      modalRef.componentInstance.ID = ID;
      modalRef.result.then(
        (result: any) => {
          if (result) {
            this.TaxCategoryMasterSelectLoad();
          }
        },
        () => { }
      );
    } else {
      this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
    }
  }

  ExcelDump() {
    if (this.TableDatas.length == 0) {
      this.toast.show({ message: 'No Data Found', type: toastTypeEnum.warning });
    } else {
      this.download.exportToExcelWithProgress(this.TableDatas, 'Tax Category Master')
    }
  }
}
